// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import axios from 'axios'
// import Swiper from "swiper"
// eslint-disable-next-line no-unused-vars
import formurlencoded from 'form-urlencoded'
import _$ from './helpers/base.js'
import _vueBase from './helpers/vue/base.js'
import Print from './helpers/print.js' // 注册
import './assets/PageCommon/css/bootstrap.min.css'
import './assets/PageCommon/css/base.css'
import './assets/PageCommon/css/jquery.alerts.css'
import VueLazyload from 'vue-lazyload'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import moment from 'moment'
import * as echarts from 'echarts'
// 组件库引用
import './assemblys/assemblys.js'
Vue.use(Print)
Vue.use(VueLazyload, {
  loading: require('./assets/PageCommon/img/NOTICE.jpg'), // 加载中图片，一定要有，不然会一直重复加载占位图
  error: require('./assets/PageCommon/img/404.png') // 加载失败图片
})
Vue.use(Vuex)
Vue.use(Element)
Vue.prototype.$echarts = echarts
axios.defaults.withCredentials = true
window.$ = {}
// eslint-disable-next-line no-undef
_$.extend('$', $, _$) // $扩展
_vueBase.extend(Vue, _vueBase) // vue扩展
Vue.config.productionTip = false
Vue.prototype.$axios = axios
// axios.defaults.baseURL = process.env.BASE_API // "";
// eslint-disable-next-line no-undef
axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? process.env.BASE_API : GLOD.BASE_API
Vue.prototype.user = null
Vue.prototype.massageOpen = null
Vue.prototype.$moment = moment

if (process.env.NODE_ENV === 'development') {
  // 开发环境
  Vue.prototype.domainUrlUtil = {
    imageResources: 'http://shopadmin-ui.dev.dfmjyzx.com/api',
    // staticResources: 'http://gateway.dev.dfmjyzx.com/api_pc/resources/front',
    urlResources: 'http://gateway.dev.dfmjyzx.com/api_pc',
    imageUrl: process.env.BASE_API

  }
} else if (process.env.NODE_ENV === 'testing') {
  // 测试环境
  Vue.prototype.domainUrlUtil = {
    imageResources: 'http://shopadmin-ui.test.dfmjyzx.com/api',
    // staticResources: 'http://gateway.test.dfmjyzx.com/api_pc/resources/front',
    urlResources: 'http://gateway.test.dfmjyzx.com/api_pc',
    imageUrl: process.env.BASE_API
  }
} else if (process.env.NODE_ENV === 'production') {
  // 线上打包 prod 统一走这个配置
  // 正式环境
  Vue.prototype.domainUrlUtil = {
    // eslint-disable-next-line no-undef
    imageResources: GLOD.BASE_RESOURCES,
    // staticResources: GLOD.BASE_RESOURCES + '/api_pc/resources/front',
    // eslint-disable-next-line no-undef
    urlResources: GLOD.BASE_RESOURCES + '/api_pc',
    // eslint-disable-next-line no-undef
    imageUrl: GLOD.BASE_API
  }
}

// 替换图片url，如果是震坤行商品不拼接前缀
Vue.prototype.ExchangeImageUrl = function (url) {
  const reg = new RegExp('^(http|https)://')
  if (!reg.test(url)) {
    return Vue.prototype.domainUrlUtil.imageResources + url
  } else {
    return url
  }
}
// 价格在未登录的时候隐藏
Vue.prototype.HideProductPrice = function (price) {
  if (price || price === 0) {
    return price
  } else {
    return '******'
  }
}
// 商品编码显示
Vue.prototype.ShowProductCode = function (code) {
  return code.substring(3)
}

// 全局变量
var store = new Vuex.Store({
  state: {
    loginStatus: 0, // 用户是否登录状态
    isUser: 0, // 是否有用户信息
    isSowLogin: 0, // 是否显示登录框
    funLogin: () => {}, // 登录回调函数
    cartGoodNum: 0, // 购物车商品数量
    compareGoodNum: 0, // 对比框商品数量
    massageOpen: 0 // 是否为第一次登录消息弹出
  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js